import React, { useState, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { DialogConfirm, DialogDelete } from "../../../components/DialogService/DialogService";
import { FooterButtonSigleCustom, FooterButtonCustomLabel } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import ValidateService from "../../../components/ValidateService/ValidateService";
// import { formatDateFile } from "../../../utilities/DateUtil";
import { DialogUpload } from "../../../components/DialogService/DialogService";

// SERVICE
import { pCtContractAttachmentUpdate } from "../../../service/400/P417Service";
import { genGetBranchInfo, genContractAttachmentTypeList } from "../../../service/GEN/GenService";
import { commonUpload } from "../../../service/APP/AppService";
import { deCodeBase64 } from "../../../components/UploadPic/UploadPicUtil";

export default function P417({ dialog, setDialog, onGetpCtContractInfo }) {
    const toast = useRef(null);
    const [errData, setErrData] = useState(null);
    const [formObject, setformObject] = useState({ contractNo: "", involvedDesc: "", telephone: "", userId: "", attachmentId: 0 });
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    // DIALOGF
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => {},
        onCancle: () => {},
        footerBtn: () => {},
    });

    //File
    const [dataFile, setDataFile] = useState(null);
    const [dialogUpload, setDialogUpload] = useState({ dialog: false, show: false });
    const [filename, setFilename] = useState("");

    // DropDown
    const [contractAttachmentTypeItem, setContractAttachmentTypeItem] = useState([]);

    useEffect(() => {
        if (dialog.dialog_417.open === true) {
            setformObject({ ...formObject, ...dialog.dialog_417.dataSet, userId: dialog.dialog_417.userId, contractNo: dialog.dialog_417.contractNo });
        }
        onGetContractAttachmentTypeList();
    }, []);

    useEffect(() => {
        onGetContractAttachmentTypeList();
    }, [formObject]);

    const onGetContractAttachmentTypeList = () => {
        const req = { userId: setViewForm("userId") };
        genContractAttachmentTypeList(req).then(
            (res) => {
                setLoading(false);
                setContractAttachmentTypeItem(res);
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const setViewForm = (key) => {
        return formObject[key] === "" || formObject[key] === null ? "" : formObject[key];
    };

    const setValueForm = (key, val) => {
        setformObject({ ...formObject, [key]: val });
    };

    const validation = (object, act) => {
        if (act === "D") {
            return true;
        } else {
            if (object.attachmentCode === "") {
                setSubmitted(true);
                return false;
            } else {
                setSubmitted(false);
                return true;
            }
        }
    };
    const handlerCloseDialog = () => {
        setDialog({ ...dialog, dialog_417: { open: false, action: "", dataSet: null } });
    };
    const handlerSettingDialogConfirm = (header, content) => {
        setdialogOption({
            ...dialogOption,
            header: header,
            content: content,
            footerBtn: () => footerButtonSingle(),
            onCancle: () => setConfirmDialog(false),
        });
        setConfirmDialog({ open: true });
    };

    const submitForm = (act) => {
        if (validation(formObject, act)) {
            const req = {
                actionCode: act,
                attachmentCode: setViewForm("attachmentCode"),
                attachmentDetail: setViewForm("attachmentDetail"),
                attachmentFileName: filename,
                attachmentId: setViewForm("attachmentId"),
                contractNo: setViewForm("contractNo"),
                userId: setViewForm("userId"),
            };
            pCtContractAttachmentUpdate(req).then(
                (res) => {
                    setLoading(false);
                    handlerSettingDialogConfirm(res[0].statusCode === "C" ? "" : "", res[0].statusText);
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const onHide = () => {
        handlerCloseDialog();
        setformObject({});
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            submitForm("D");
            setDeleteDialog(false);
        };
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const footerButtonSingle = (orNo) => {
        const con = () => {
            handlerCloseDialog();
            onGetpCtContractInfo();
        };
        return <FooterButtonSigleCustom btnLabel="ตกลง" icon="pi pi-check" onClick={() => con()} />;
    };
    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="บันทึก" icon="pi pi-save" onClick={() => submitForm(dialog.dialog_417.action === "EDIT" ? "U" : "A")} className="p-button-success p-button" />
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => handlerCloseDialog()} className="p-button-danger p-button" />
                <Button label="ลบรายการ" icon="pi pi-trash" onClick={() => setDeleteDialog({ open: true })} className="p-button-danger p-button" disabled={dialog.dialog_417.action === "EDIT" ? false : true} />
            </div>
        );
    };

    const onSaveFile = () => {
        let reqGen = {
            orderNo: "",
            requestNo: setViewForm("contractNo").replace("/", ""),
            userId: setViewForm("userId"),
        };
        setLoading(true);
        genGetBranchInfo(reqGen).then(
            (res) => {
                setLoading(false);
                if (res && res.length > 0) {
                    onUpload(res[0]);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );

        setDialogUpload({ dialog: false, show: false });
    };
    const onUpload = (dataObj) => {
        let req = {
            base64Pic: deCodeBase64(dataFile.fileUpload),
            // picName: formatDateFile(new Date(), true) + "_" + setViewForm("userId"),
            picName: dataFile.fileUpload.fileName.replace(/\.[^/.]+$/, ""),
            requestNo: setViewForm("contractNo").replace("/", ""),
            userId: setViewForm("userId"),
            branchId: dataObj.branchCode,
            fiscalYear: dataObj.fiscalYear,
            picType: dataFile.fileUpload.typefile,
        };
        setLoading(true);
        commonUpload(req).then(
            (res) => {
                setLoading(false);
                if (res && res.status === "Success") {
                    setFilename(dataFile.fileUpload.fileName.replace(/\.[^/.]+$/, ""));
                    setDataFile({
                        ...dataFile,
                        picPath: res.picPath,
                        picUrl: res.picUrl,
                    });
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด commonUpload :`, `${res.status}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };
    return (
        <>
            <ValidateService err={errData} setErr={setErrData} />
            <Loading loading={loading} />
            <Dialog header="เอกสารที่เกี่ยวข้อง" visible={dialog.dialog_417.open} style={{ width: "55vw" }} footer={renderFooter()} onHide={() => onHide()} blockScroll={true} className="p-fluid" maximizable={true}>
                <Toast ref={toast} position="top-right" />
                <div className="p-grid" style={{ marginBottom: 30 }}>
                    <div className="p-col-12">
                        <label>
                            เลขที่สัญญา<span style={{ color: "red" }}>*</span>
                        </label>
                        <InputText value={setViewForm("contractNo")} maxLength={20} />
                    </div>

                    <div className="p-col-6">
                        <label>
                            ประเภทเอกสาร<span style={{ color: "red" }}>*</span>
                        </label>
                        <Dropdown
                            className={submitted && !formObject.attachmentCode ? "p-invalid" : ""}
                            placeholder="เลือก ประเภทสัญญา"
                            optionLabel="attachmentDesc"
                            optionValue="attachmentCode"
                            value={setViewForm("attachmentCode")}
                            onChange={(e) => setValueForm("attachmentCode", e.target.value)}
                            options={contractAttachmentTypeItem}
                        />
                        {submitted && !formObject.attachmentCode && validateInputText("attachmentCode", "ประเภทสัญญา")}
                    </div>
                    <div className="p-col-6">
                        <label>รายละเอียด</label>
                        <InputText value={setViewForm("attachmentDetail")} onChange={(e) => setValueForm("attachmentDetail", e.target.value)} maxLength={100} />
                    </div>

                    <div className="p-col-4">
                        <label>ไฟล์แนบ</label>
                        <br />
                        <Button label="เพิ่มไฟล์" icon="pi pi-upload" onClick={() => setDialogUpload({ dialog: true, show: true })} className="p-button-success p-button" style={{ width: 100 }} />
                        <label>{filename}</label>
                    </div>
                </div>
            </Dialog>
            <DialogDelete visible={deleteDialog.open} header="" modal footer={footerButton()} onHide={() => setDeleteDialog(false)} textContent="ยืนยันเพื่อลบรายการ หรือกดยกเลิกเพื่อยกเลิกการทำรายการ" />
            <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />
            <DialogUpload
                dialog={dialogUpload}
                setDialog={setDialogUpload}
                dataFile={dataFile}
                setDataFile={setDataFile}
                onSaveFile={onSaveFile}
                // typeFile =".jpg"
            />
        </>
    );
}
